export default __webpack_public_path__ + "static/media/stars_logo.270c9999.svg";